module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA8UlEQVRYhe2SMQrCMBiFX/P3Ehk9gjdwzOYuIihGr6SmiCBOXkCPIHgAVzcP0b91qIIOjTU0ydI3vSHwf7x8yfW+IkSMiHm8A+gAACANfXD9GClOyECUIME6OACXZJBAvnuML5CfPboDHYAXCTe3sWJRmS6I9bJ3ONW99bIAl2RQySZfvTa+vkDW9GAAjRMdwFlCc5koBpmSAKJcL/r7WtFscV6Ai+aieQHAH6L5Amgl0QGsEmbnqcohDAiglLUe7JxEs8W6wJdohbtozgBoSTRb0uw4UwwyENXM8+G29ZltESFmtgIgwMy/AKKmA4gO8ATW3kKWLkWoXQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/NB/second_signal_5.png
// module id = KMIz
// module chunks = 1